/**
 * Number validation and parsing utilities
 */

/**
 * Gets number values for the data grid, taking into account possible nulls or invalid numerical values, and handles 0 and -0 as 0.
 * @param value - Any value to convert to a number
 * @returns Valid number or null if invalid
 * @example
 * getNumberValue(42) // 42
 * getNumberValue("123") // 123
 * getNumberValue(0) // 0
 * getNumberValue(-0) // 0
 * getNumberValue(null) // null
 * getNumberValue("invalid") // null
 */
export const getNumberValue = (value: any): number | null => {
  /*
  This helper function gets number values for the data grid, taking into account possible nulls or invalid numerical values, and handles 0 and -0 as 0.
  */
  if (value !== null && value !== undefined && !isNaN(value) && value !== "") {
    if (value === 0 || value === -0) {
      return 0;
    }

    return value;
  }

  return null;
};

/**
 * Converts duration in seconds to minutes
 * @param value - Duration in seconds
 * @returns Duration in minutes or null if invalid
 * @example
 * getDurationInMinsFromSecsValue(120) // 2
 * getDurationInMinsFromSecsValue(null) // null
 */
export const getDurationInMinsFromSecsValue = (value: any): number | null => {
  if (value) {
    return value / 60;
  }
  return null;
};